<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>添加设备</BreadcrumbItem>
        </Breadcrumb>
        <div class="dev_data">
          <div><span style="color: red;">*</span>设备编号<Input v-model="devForm.deviceNo" style="width: 300px" :maxlength=32 /></div>
          <div><span style="color: red;">*</span>合作伙伴<Input v-model="devForm.manufacturer" disabled style="width: 300px" :maxlength=32 /></div>
          <div><span style="color: red;">*</span>设备类型<Input v-model="devForm.deviceType" disabled style="width: 300px" :maxlength=32 /></div>
          <div><span style="color: red;"></span>学校名称<Input v-model="devForm.campusName" style="width: 300px" :maxlength=32 /></div>
          <div class="btn">
            <Button type="primary" style="width: 120px;" @click="submit">确定</Button>
            <Button style="width: 120px;" @click="goBackPage">取消</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api/index'
import TopOpe from '../top-ope/top-ope'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess, nError} from '../../util/notice'

export default {
  components: {TopOpe},
  name: 'add-device',
  data () {
    return {
      devForm: {
        deviceNo: '',
        manufacturer: '杭州大麦物联科技有限公司',
        deviceType: 'DM-DC01-P',
        campusName: ''
      }
    }
  },
  methods: {
    goBackPage () {
      this.$router.push({
        path: '/upgrade_management'
      })
    },
    submit () {
      if (!this.devForm.deviceNo) {
        nError('设备编号不能为空')
        return false
      }
      if (!this.devForm.manufacturer) {
        nError('合作厂商不能为空')
        return false
      }
      if (!this.devForm.deviceType) {
        nError('设备类型不能为空')
        return false
      }
      this.$axios.post(`${httpUrl.url}/manage/device/add`, this.devForm)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.$router.push({
              path: '/upgrade_management'
            })
          }
        })
        .catch(
          errorHandler('添加失败')
        )
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    width: 100%;
    height: 100%;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .dev_data {
    margin-top: 80px;
  }

  .dev_data div {
    margin: 10px;
    text-align: center;
  }

  .btn button {
    margin: 30px 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/upgrade-management/add-device.vue